<template>
  <div class="container">
    <div class="top_title">个人信息</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="banner"></div>
      <div class="student_info_title">
        <span class="icon_student_info"></span>
        <span>学员信息</span>
        <router-link tag="span" to="/H020010" class="icon_add_student"></router-link>
      </div>
      <div class="student_items">
        <div v-for="item,index in info.dataList" class="weui-cells item">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>姓名</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="item.I_STUDENT_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>校区</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="item.I_SCHOOL_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>班级</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="item.I_CLASS_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>老师</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="item.I_TEACHER_NAME" />
            </div>
          </div>
        </div>
      </div>
      <div class="teacher_info_title">
        <span class="icon_parent_info"></span>
        <span>用户信息</span>
      </div>
      <div class="weui-cells item" style="border: 0!important;">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>我是</p>
          </div>
          <div class="weui-cell__ft family_member">
            <span :class="{active: info.I_RELATION_SHIP == '爸爸'}" @click="info.I_RELATION_SHIP = '爸爸'">爸爸</span>
            <span :class="{active: info.I_RELATION_SHIP == '妈妈'}" @click="info.I_RELATION_SHIP = '妈妈'">妈妈</span>
            <span :class="{active: info.I_RELATION_SHIP == '其他'}" @click="info.I_RELATION_SHIP = '其他'">其他</span>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>手机</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" class="input_text tel" v-model="info.I_TEL" placeholder="请输入手机号"/>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>验证码</p>
          </div>
          <div class="weui-cell__ft identify_code">
            <input type="text" v-model="info.I_IDENTIFY_CODE" placeholder="请输入验证码" />
            <button type="button" :disabled="disabled" @click="sendcode" class="btns">{{btntxt}}</button>
          </div>
        </div>
      </div>

      <button class="bottom_btn" @click="save">保存</button>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: false,
          jchd: false,
          yyst: false,
          wd: true,
        },
        info: {
          dataList: [],
          I_RELATION_SHIP: ""
        },
        I_IDENTIFY_FLAG: "N",
        btntxt: "获取验证码",
        disabled: false,
      }
    },
    components: {
      Footer
    },
    created() {
      DataRequestFactory.I030010().then((response) => {
        this.info = response

        if(this.info.I_TEL == null || this.info.I_TEL == "") {
          this.I_IDENTIFY_FLAG = "Y"
        }
      })
    },
    methods: {
      //验证手机号码部分
      sendcode() {
        var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
        if(this.info.I_TEL == '' || this.info.I_TEL == null){
          weui.topTips("请输入手机号码");
        // }else if(!reg.test(this.info.I_TEL)){
        //   weui.topTips("手机格式不正确");
        }else {
          this.time = 60;
          this.disabled = true;
          this.timer();
          let requestParams = {
            "I_TYPE": "手机验证码",
            "I_TEL": this.info.I_TEL,
          }
          DataRequestFactory.C020010(requestParams).then((response) => {
            if(response.resultCode == 0) {
            console.log(response)
          }
        })
        }
      },
      timer() {
        if (this.time > 0) {
          this.time--;
          this.btntxt = this.time+"s后重新获取";
          setTimeout(this.timer, 1000);
        } else{
          this.time=0;
          this.btntxt="获取验证码";
          this.disabled=false;
        }
      },
      save () {
        let requestParams =
              {
                I_RELATION_SHIP: this.info.I_RELATION_SHIP,
                I_TEL: this.info.I_TEL,
                I_IDENTIFY_FLAG: this.I_IDENTIFY_FLAG,
                I_IDENTIFY_CODE: this.info.I_IDENTIFY_CODE
              }
        DataRequestFactory.I030011(requestParams).then((response) => {
          if(response.resultCode == 0) {
//          this.$router.replace({ name: 'H080020'})
            weui.topTips("保存成功");
          }
        })
      }
    },
    mounted() {
      var win_h = $(window).height();  //关键代码
      $("body").height(win_h);  //关键代码

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H030010.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H030010.vue